<template>
  <div class="calls col-12 h-100 w-100" v-if="currentUser.rights.doCalls">
    <!-- daily statistic block start -->
    <div class="content-wrapper-transparent row justify-content-between mb-0" style="margin-top:-25px;">
      <div class="mb-0 d-flex flex-column justify-content-between text-center" :class="status == 'offline'?'col-3':'col-2'">
        <h4>Обработано звонков</h4>
        <span class="call-statistics">{{callsTotalTime.length}}</span>
      </div>
      <div class="mb-0 d-flex flex-column justify-content-between text-center" :class="status == 'offline'?'col-3':'col-2'">
        <h4>Минимальное время</h4>
        <span class="call-statistics">{{minCallTime}}</span>
      </div>
      <div class="d-flex flex-column justify-content-between text-center" :class="status == 'offline'?'col-3':'col-2'">
        <h4>Среднее время</h4>
        <span class="call-statistics">{{averageCallTime}}</span>
      </div>
      <div class="d-flex flex-column justify-content-between text-center" :class="status == 'offline'?'col-3':'col-2'">
        <h4>Максимальное время</h4>
        <span class="call-statistics">{{maxCallTime}}</span>
      </div>
      <div class="align-self-center col-2 d-flex justify-content-center justify-content-lg-end mt--0 pr-0">
        <span
          class="btn-lg btn-outline-danger end-session"
          v-show="status !== 'offline'"
          @click="endSession()"
          :class="{disabled: exitAfterSubmit}"
          :disabled="exitAfterSubmit"
          v-html="!exitAfterSubmit ? 'Завершить&nbsp;сеанс' : 'Сеанс&nbsp;завершен'">
        </span>
      </div>
    </div>
    <!-- daily statistic block end -->

    <!-- timer block start -->
    <!-- <div class="content-wrapper row justify-content-between mb-5" v-show="status=='busy'">
      <div>
        <h4 class="d-lg-inline mr-lg-2">Время обработки:</h4>
        <span class="call-statistics">{{formatedCallTime}}</span>
      </div>
      <button type="button" class="btn-lg btn-outline-danger end-session align-self-center" :class="{disabled: callState=='completed'}" :disabled="callState=='completed'" @click="endCall()">
        <span v-html="this.callState == 'completed'?'Разговор завершен':'Завершить разговор'"></span>
      </button>
    </div> -->
    <!-- timer block end -->

    <div class="position-relative row align-content-start" :class="bannerStyles" v-if="status !== 'busy'">
      <!-- offline block start -->
      <div v-show="status == 'offline'" class="content-wrapper-transparent state-container h-100 w-100">
        <div class="align-items-center d-flex flex-column py-5 h-100 justify-content-center w-100">
          <template v-if="sipSettingsDefined && sipAccountRegistered">
            <h1 class="mb-5 text-center">Сеанс неактивен</h1>
            <p class="text-center">В данный момент, звонки на Вас не будут направляться.</p>
            <p class="mb-5 text-center">Как только будете готовы принимать звонки, нажмите кнопку "Начать принимать звонки"</p>
            <button type="button" class="btn btn-info btn-lg px-4" @click="stateOnline()">Начать принимать звонки</button>
          </template>
          <template v-if="!sipSettingsDefined">
            <h1 class="mb-5 text-center">Не установлены настройки телефонии</h1>
            <p>Пожалуйста, обратитесь к администратору для настройки SIP-аккаунта</p>
          </template>
          <template v-if="sipSettingsDefined && !sipAccountRegistered">
            <h1 class="mb-5 text-center">Не зарегистрирован SIP-аккаунт</h1>
            <p>Пожалуйста, проверьте ваш SIP-клиент или аппарат и после получения регистрации обновите страницу.</p>
            <p>Если проблему не удаётся устранить самостоятельно, обратитесь к администратору за помощью</p>
          </template>
        </div>
      </div>
      <!-- offline block end -->

      <!-- ringing block start -->
      <div v-if="callsQueue.length == 0 && status == 'ringing'" class="content-wrapper-trnasparetn state-container position-relative justify-content-center w-100">
        <h1 class="mb-4 mw-100" style="color:#fff;">Сеанс активен</h1>
        <div class="text-center mb-5"><i class="fal fa-spinner fa-pulse" style="color: #fff;font-size: 3em;"></i></div>
        <h2 class="text-center mb-5" style="color:#fff;">Ожидание входящих звонков</h2>
        <div class="text-center">
          <span
            class="btn-lg btn-outline-danger end-session "
            v-show="status !== 'offline'"
            @click="endSession()"
            :class="{disabled: exitAfterSubmit}"
            :disabled="exitAfterSubmit"
            v-html="!exitAfterSubmit ? 'Завершить&nbsp;сеанс' : 'Сеанс&nbsp;завершен'">
          </span>
        </div>
      </div>

      <div class="row w-100" v-show="status=='ringing'" v-for="call in callsQueue" :key='call.id'>
        <div class="col-6 px-0 mx-auto" >
          <div class="content-wrapper flex-column justify-content-between mb-5 pb-4 pl-4 state-container" style="background: rgba(255, 255, 255, 0.8);">
            <h1 class="text-center">Входящий звонок {{hiddenNumber(call.src_number)}}</h1>
            <div class="align-self-start h5">
              <p class="mb-1">Компания: {{call.company}}</p>
              <p class="mb-1">Приветствие: {{call.greeting}}</p>
            </div>
            <!-- <button
              type="button"
              class="btn btn-info px-5"
              @click="acceptCall(call.id)"
              v-if='!index && softPhone'
            >Принять звонок</button> -->
          </div>
        </div>
      </div>
      <!-- ringing block end -->
    </div>

    <div class="row" v-if="status=='busy'">
      <!-- script-block start -->
      <div class="col-lg-7 col-xl-8 mb-xl-0 px-0 mb-3 mb-lg-0">
        <div class="align-items-center content-wrapper d-flex flex-column h-100 mr-lg-5 pt-4 text-center">
          <h5 class="mb-4" v-if="!iframeLoaded">Вы приняли звонок от лица компании <span class="company-name">{{currentCall.company}}</span></h5>
          <h6 class="mb-5" v-if="!iframeLoaded">Приветствие: <span>{{currentCall.greeting}}</span></h6>
          <div class="d-flex align-items-center justify-content-center graph-container position-absolute mt-5" v-if="!iframeLoaded">Загрузка сценария разговора<i class="fas fa-spinner fa-pulse"></i></div>
          <previous-call-info v-if="currentCall" :current-call="currentCall" :key="currentCall.id"></previous-call-info>
          <iframe :src="systemSettings.mz_api_host + '/api/?action=getScriptPage&api_key=DFjgkVQsi3ws98loLlVciNAICP76JhQl&script_project_id=' + currentCall.project_mz_id+'&hyperscript_login=' + this.sipInfo.hyperscript_login + '&for_operator=1'" class="w-100 h-75" frameborder="0" @load="iframeLoaded = true"></iframe>
          <!-- <iframe :src="'https://lk.scriptogenerator.ru/tables/103956/table/498/link/88d4fb14e4b84ff48d2c7071d296383d/share/'" class="w-100 h-75" frameborder="0" @load="iframeLoaded = true"></iframe>-->
        </div>
      </div>
      <!-- script-block end -->

      <!-- form-block start -->
      <form
        v-show="status=='busy'"
        @submit.prevent="validateForm"
        class="content-wrapper col-lg-5 col-xl-4 pt-4 pb-1 w-100"
        name="questionnaire"
      >
        <h2 class="mb-2 text-center" :style="this.callTime > 119 ? 'color:#ff0000;' : ''">{{formatedCallTime}}</h2>
        <div class="mb-2 text-center">
          <span v-html="this.callState == 'completed'?'Разговор завершен, отправьте форму':'Идёт разговор'"></span>
        </div>
        <!-- <div class="mb-4 text-center">
          <h5 class="mb-0 d-inline">Заполните форму</h5>
        </div> -->

        <!-- generated fields start -->
        <div class="form-group row mb-3" v-for="field in formFields" :key="field.name">
          <label :for="'fieldID_'+field.name" class="col-xl-3 pt-1 col-form-label">{{ field.label }}</label>
          <div class="col-xl-9">
            <template v-if="field.type == 'text' || field.type == 'email'">
              <input :type="field.type" class="form-control questionnaire-control" :id="'fieldID_'+field.name" :name="field.name" :required="field.is_required > 0 ? true : false" v-model="field.value">
            </template>
            <template v-if="field.type == 'checkbox'">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input questionnaire-control" :id="'fieldID_'+field.name" :name="field.name" :required="field.is_required > 0 ? true : false" v-model="field.value" :for="'fieldID_'+field.id">
                <label class="custom-control-label" :for="'fieldID_'+field.name"></label>
              </div>
            </template>
            <template v-if="field.type == 'select'">
              <select class="custom-select questionnaire-control" :id="'fieldID_'+field.name" :name="field.name" :required="field.is_required > 0 ? true : false">
                <option value="" disabled selected>Выберите один вариантов</option>
                <option v-for="(val, ind) in field.values" :key="ind" :value="val">{{ val }}</option>
              </select>
            </template>
            <template v-if="field.type == 'target_select'">
              <select class="custom-select questionnaire-control" :id="'fieldID_'+field.name" :name="field.name" :required="field.is_required > 0 ? true : false">
                <option value="" disabled selected>Выберите цель звонка</option>
                <option v-for="val in field.values" :key="val.id" :value="val.id">{{val.name}}</option>
              </select>
            </template>
            <template v-if="field.type == 'textarea'">
              <textarea
                class="form-control questionnaire-control"
                :id="'fieldID_'+field.name"
                :name="field.name"
                v-model="field.value"
                rows="3"
                :required="field.is_required > 0 ? true : false"
              ></textarea>
            </template>
            <template v-if="field.type == 'datalist'">
              <input
                type="text"
                class="form-control questionnaire-control"
                :id="'fieldID_'+field.name"
                :name="field.name + field.multiple ? '[]' : ''"
                v-model="field.value"
                :list="'fieldID_'+field.name+'_list'"
                :required="field.is_required > 0 ? true : false"
                :multiple="field.multiple"
              >
              <datalist :id="'fieldID_'+field.name+'_list'">
                <option
                  v-for="(val, ind) in field.values"
                  :key="ind"
                  :value="val"
                ></option>
              </datalist>
            </template>
            <template v-if="field.type === 'datetime-local'">
              <input-datetime v-model="field.value"></input-datetime>
            </template>
          </div>
        </div>
        <!-- generated fields end-->

        <div class="form-group row mb-3 justify-content-center">
          <div class="button-wrapper position-relative">
            <button type="submit" class="btn btn-info px-5">Отправить</button>
          </div>
          <div class="button-wrapper position-relative">
            <div class="d-block btn btn-outline-danger mb-3"  v-on:click="hangup()">Завершить звонок</div>
          </div>
        </div>

        <div v-if="hasTransfer">
          <h3 class="text-center">Переводы</h3>
          <div class="d-block btn btn-outline-danger mb-3"  v-on:click="stopTransfer()">Отменить перевод</div>
          <div class="d-block btn btn-info mb-3" v-for="transfer in transfers" v-bind:key="transfer.value" v-on:click="softTransfer(transfer.value)">
            {{ transfer.title }} ({{ transfer.value }})
          </div>
        </div>
      </form>
      <!-- form-block end -->
    </div>
  </div>

</template>

<script>
import InputDatetime from "./custom-fields/src/InputDatetime";
import PreviousCallInfo from "./PreviousCallInfo";
export default {
  components: {
    PreviousCallInfo,
    InputDatetime,
  },
  data () {
    return {
      status: 'offline',
      callState: null,
      callId: 0,
      currentCall: null,
      iframeLoaded: false,
      connection: null,
      isAlertVisible: false,
      exitAfterSubmit: false,
      wsCloseSuccessfully: false,
      softPhone: true,
      counter: null,
      callTime: 0,
      callsTotalTime: [],
      callsQueue: [],
      formFields: [],
      hasTransfer: 0,
      transfers: [],
      sipSettingsDefined: true,
      sipAccountRegistered: true,
      sipInfo: false,
    }
  },
  computed: {
    systemSettings: function () {
      return this.$store.getters.system_settings
    },
    currentUser: function () {
      return this.$store.getters.user
    },
    bannerStyles: function () {
      return this.status === 'ringing' ? ['flex-wrap'] : ['flex-column', 'align-items-center', 'mb-4']
    },
    formatedCallTime: function () {
      return this.parseTimerData(this.callTime)
    },
    minCallTime: function () {
      if (!this.callsTotalTime.length) return this.parseTimerData(0)
      let seconds = Math.min(...this.callsTotalTime)
      return this.parseTimerData(seconds)
    },
    averageCallTime: function () {
      if (!this.callsTotalTime.length) return this.parseTimerData(0)
      let seconds = this.callsTotalTime.reduce((a, b) => a + b) / this.callsTotalTime.length
      return this.parseTimerData(Math.round(seconds))
    },
    maxCallTime: function () {
      if (!this.callsTotalTime.length) return this.parseTimerData(0)
      let seconds = Math.max(...this.callsTotalTime)
      return this.parseTimerData(seconds)
    },
    menuState: {
      get: function () {
        return this.$store.getters.menuState
      },
      set: function (newValue) {
        this.$store.commit('setMenuState', newValue)
      }
    },
    alertState: {
      get: function () {
        return this.$store.getters.alertState
      },
      set: function (newValue) {
        this.$store.commit('setAlertState', newValue)
      }
    },
    accessDenial: {
      get: function () {
        return this.$store.getters.accessDenial
      },
      set: function (newValue) {
        this.$store.commit('setAccessDenial', newValue)
      }
    }
  },
  methods: {
    setConnection: function () {
      this.connection = new WebSocket(this.systemSettings.websocket_host)
      this.connection.onopen = () => {
        this.sendDataToWebSocket('connectUser', {Page: "calls"})
        this.sendDataToWebSocket('operatorEntryCallPage', {Operator_id: this.currentUser.id})
      }
      this.connection.onmessage = this.wsOnMessage
      this.connection.onerror = (event) => {
        console.error("WebSocket error observed:", event)
      }
      this.connection.onclose = (event) => {
        console.warn("WebSocket close:", event)
        if (this.wsCloseSuccessfully || this.status === 'busy') return
        this.reportDisconnect()
      }
    },
    wsOnMessage: function (event) {
      let data = JSON.parse(event.data)
      let wsd = data.Data === '' ? '' : JSON.parse(data.Data)
      console.log(data)
      switch (data.Action) {
        case 'addCall':
          this.wsAddCall(data, wsd)
          break
        case 'operatorAnswerCall':
          if (wsd.Operator_id == this.currentUser.id) {
            this.wsOperatorAnswerCall(data, wsd)
          } else {
            this.callsQueue = this.callsQueue.filter(call => call.id != wsd.Call_id)
          }
          break
        case 'endCall':
          if (wsd.Call_id == this.callId) {
            this.endCall()
          } else {
            this.callsQueue = this.callsQueue.filter(call => call.id != wsd.Call_id)
          }
          break
      }
    },
    sendDataToWebSocket: function (action, data) {
      data = typeof data == 'object' ? JSON.stringify(data) : data
      let wsd = {
        Action: action, // Событие
        Data: data, // Данные события json объект строкой
        User_id: this.currentUser.id, // id пользователя, который отправляет
        Client_id: this.currentUser.client_id, // id Клиента, который отправляет
        Token: this.currentUser.token // Токен пользователя для проверки авторизации
      }
      let msg = JSON.stringify(wsd)
      let lenbyte = encodeURI(msg).split(/%..|./).length - 1
      let len = '' + lenbyte
      while (len.length < 5) {
        len += ' '
      }
      this.connection.send(len + msg)
    },
    reportDisconnect: function () {
      this.status = 'offline'
      this.alertState.active = true
      this.alertState.message = 'Потеряно соединение с сервером, обновите страницу'
    },
    stateOnline: function () {
      if (/[23]/.test(this.connection.readyState)) return
      this.status = 'ringing'
      this.unpauseOperator()
      this.requestCallsQueue()
    },
    requestCallsQueue: function () {
      this.axios.get(this.systemSettings.api_host + '/ajax.php?action=getCallsForOperator')
        .then(response => this.fillCallsQueue(response.data.data))
        .then(this.sendDataToWebSocket('operatorStartWorking', {type: "incomming", Operator_id: this.currentUser.id}))
        // .then(this.findAnsweredCall())
    },
    fillCallsQueue (data) {
      data.forEach(call => {
        for (let [key, val] of Object.entries(call)) {
          call[key] = val = Number.isNaN(+val) ? val : +val
        }
        var c = this.callsQueue.find(item => item.id == call.id)
        if (c === undefined) {
          this.callsQueue.push(call)
        }
      })
      this.findAnsweredCall()
    },
    hiddenNumber: function (phone) {
      if (`${phone}`.length >= 10) {
        phone = `${phone}`
          .split('')
          .map(function (el, i) {
            el = /[3-5]/.test(i) ? '*' : el
            return el
          })
          .join('')
      }
      return phone
    },
    wsAddCall: function (data, wsd) {
      this.axios.get(this.systemSettings.api_host + '/ajax.php?action=getCallRingingById&id=' + wsd.Call_id)
        .then(response => (this.callsQueue.push(response.data.data)))
    },
    findAnsweredCall: function () {
      var c = this.callsQueue.find(item => item.operator_id == this.currentUser.id)
      if (c !== undefined) {
        this.getProject(c.project_id)
        this.acceptCall(c.id)
      }
    },
    acceptCall: function (id) {
      this.currentCall = JSON.parse(JSON.stringify(this.callsQueue.find(item => item.id === id)))
      this.callId = id
      this.startTimer()
      this.status = 'busy'
      this.menuState.active = false
      this.alertState.message = 'Не завершен разговор'
      this.callsQueue = this.callsQueue.filter(call => call.id != this.currentCall.id)
    },
    wsOperatorAnswerCall: function (data, wsd) {
      if (wsd.Operator_id != this.currentUser.id) {
        return false
      }
      this.getProject(wsd.Project_id)
      this.acceptCall(wsd.Call_id)
      this.pauseOperator()
    },
    startTimer: function () {
      let startTime = Date.now()
      this.counter = setInterval(() => {
        let nowTime = new Date().getTime()
        this.callTime = Math.round((nowTime - startTime) / 1000)
      }, 1000)
    },
    pageCloseListener: function (event) {
      event.preventDefault()
      event.returnValue = '' // string for Chrome working
    },
    getOperatorStat: function () {
      this.axios.get(this.systemSettings.api_host + '/ajax.php?action=getOpeartorStatCallPage')
        .then(response => (this.callsTotalTime = response.data.callsTotalTime))
    },
    checkSip: function () {
      this.axios.get(this.systemSettings.api_host + '/ajax.php?action=getSipInfo&user_id=' + this.currentUser.id)
        .then(response => {
          this.sipInfo = response.data.data
          if (response.data.error || this.sipInfo === false || !this.sipInfo.Status.includes('OK')) {
            this.sipAccountRegistered = false
          }
          console.log(response.data)
        })
    },
    softTransfer: function (toNumber) {
      this.axios.get(this.systemSettings.api_host + '/ajax.php?action=softTransfer&transfer=' + toNumber + '&call_id=' + this.currentCall.id)
        .then(response => {
          console.log('softTransfer', response.data)
        })
    },
    stopTransfer: function () {
      this.axios.get(this.systemSettings.api_host + "/ajax.php?action=stopTransfer&call_id=" + this.currentCall.id)
        .then(response => {
          console.log('stopTransfer', response.data)
        })
    },
    hangup: function () {
      this.axios.get(this.systemSettings.api_host + "/ajax.php?action=hangup&call_id=" + this.currentCall.id)
        .then(response => {
          console.log('hangup', response.data)
        })
    },
    pauseOperator: function () {
      this.axios.get(this.systemSettings.api_host + '/ajax.php?action=pauseOperator&user_id=' + this.currentUser.id)
      // .then(response => ())
      // пока ничего не возвращаю в надежде что всё работает
    },
    unpauseOperator: function () {
      this.axios.get(this.systemSettings.api_host + '/ajax.php?action=unpauseOperator&user_id=' + this.currentUser.id)
      // .then(response => ())
      // пока ничего не возвращаю в надежде что всё работает
    },
    getProject: function (projectID) {
      this.axios.get(this.systemSettings.api_host + '/ajax.php?action=getProject&id=' + projectID)
        .then(response => this.parseProject(response.data))
    },
    parseProject: function (projectData) {
      console.log('projectData')
      console.dir(projectData)
      this.hasTransfer = projectData.project.hasTransfer
      this.transfers = projectData.project.hasTransfer ? JSON.parse(projectData.project.transfers) : []
      projectData.fields.forEach(elem => this.formFields.push(elem))
      let targetField = {
        name: 'target',
        label: 'Цель звонка',
        type: 'target_select',
        is_required: true,
        value: '',
        values: []
      }
      projectData.results.forEach(function (elem) {
        targetField.values.push(elem)
      })
      this.formFields.push(targetField)
      console.dir(targetField.values)
    },
    parseTimerData: function (seconds) {
      let mins = Math.floor(seconds / 60)
      let sec = seconds % 60
      if (mins < 10) mins = `0${mins}`
      if (sec < 10) sec = `0${sec}`
      return `${mins} : ${sec}`
    },
    stopTimer: function () {
      clearInterval(this.counter)
      this.callsTotalTime.push(this.callTime)
      this.callTime = 0
    },
    endCall: function () {
      this.callId = 0
      this.callState = 'completed'
      this.alertState.active = false
      this.alertState.message = 'Не отправлена форма'
    },
    endSession: function () {
      if (this.status == 'busy') {
        this.exitAfterSubmit = true
      } else {
        this.stateOffline()
      }
      this.callsQueue.length = 0
    },
    validateForm: function () {
      if (this.callState !== 'completed') {
        this.alertState.active = true
      } else {
        this.formSubmit()
      }
    },
    formSubmit: function () {
      let controls = document.querySelectorAll('.questionnaire-control')
      let formForSending = {}

      for (let i = 0; i < controls.length; i++) {
        let name = controls[i].name
        formForSending[name] = controls[i].type === 'checkbox' ? controls[i].checked : controls[i].value
      }

      const needRecallByTime = this.formFields.find(v => v.name === 'need_recall_by_time' && !!v.value);
      if (needRecallByTime) {
        formForSending['need_recall_by_time'] = needRecallByTime.value;
      }

      this.callState = null
      this.iframeLoaded = false
      window.removeEventListener('beforeunload', this.pageCloseListener)
      this.menuState = {
        active: true,
        message: ''
      }
      let postData = {}
      postData.action = 'operatorSubmitForm'
      postData.call_id = this.currentCall.id
      postData.project_id = this.currentCall.project_id
      postData.CallerId = this.currentCall.src_number + '_' + this.currentCall.call_mz_id + '_' + this.currentCall.project_mz_id
      postData.work_time = this.callTime
      postData.form = formForSending

      this.axios.post(this.systemSettings.api_host + '/ajax.php', postData)
      this.alertState.active = false
      this.sendDataToWebSocket('operatorSubmitForm', {
        Call_id: this.currentCall.id,
        Operator_id: this.currentCall.Operator_id,
        Project_id: this.currentCall.project_id,
        Phone: this.currentCall.src_number,
        Result_id: document.forms.questionnaire.target.selectedIndex,
        Direction: this.currentCall.direction
      })
      if (this.exitAfterSubmit) {
        this.stateOffline()
      } else if (/[23]/.test(this.connection.readyState)) {
        this.reportDisconnect()
      } else {
        this.status = 'ringing'
        this.unpauseOperator()
      }
      this.stopTimer()
      this.formFields.length = 0
      document.forms.questionnaire.reset()
    },
    stateOffline: function () {
      this.status = 'offline'
      this.sendDataToWebSocket('operatorStopWorking', {Operator_id: this.currentUser.id})
      this.exitAfterSubmit = false
      this.pauseOperator()
    }
  },
  mounted () {
    if (this.currentUser.rights.doCalls) {
      this.getOperatorStat()
      this.setConnection()
      this.checkSip()
    } else {
      this.accessDenial = {
        active: true,
        message: 'У вас нет права доступа в раздел Обзвон'
      }
    }
  },
  beforeDestroy () {
    if (this.connection) {
      this.sendDataToWebSocket('operatorLeaveCallPage', {Operator_id: this.currentUser.id})
      this.wsCloseSuccessfully = true
      this.connection.close()
    }
    this.accessDenial = {
      active: false,
      message: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/calls.vue